module.exports = __webpack_public_path__ + "img/Logo_SFR.9ca17f39.svg";